import { Component, Vue } from 'vue-property-decorator';

@Component
export default class RegExpCore extends Vue {

	regExpDigitalSign: RegExp = /^[0-9a-f]+$/gi

	validateRegExpList(v: string, regExpList: string[]) {
		return regExpList.every(i => (new RegExp(i)).test(v));
	}

}